/**
 * Homepage portfolio feed from kurtenj-web-images repo via jsDelivr.
 * Loads manifest.json from the repo; each entry becomes a grid shot.
 */

import { PORTFOLIO_IMAGES_CDN_BASE, PORTFOLIO_MANIFEST_URL } from '../constants.js';

/** Mutable list of portfolio items. Populated by loadPortfolioFeed(). */
export const portfolioItems = [];

/**
 * Manifest entry: { id: number, file: string } or just a string filename.
 * @typedef {{ id?: number, file: string } | string} ManifestEntry
 */

/**
 * Fetch manifest from jsDelivr and populate portfolioItems with full CDN URLs.
 * @returns {Promise<void>}
 */
export function loadPortfolioFeed() {
  return fetch(PORTFOLIO_MANIFEST_URL)
    .then((res) => {
      if (!res.ok) throw new Error(`Manifest ${res.status}`);
      return res.json();
    })
    .then((/** ManifestEntry[] */ raw) => {
      const base = PORTFOLIO_IMAGES_CDN_BASE.replace(/\/$/, '');
      const list = Array.isArray(raw) ? raw : [];
      portfolioItems.length = 0;
      list.forEach((entry, index) => {
        const file = typeof entry === 'string' ? entry : entry?.file;
        if (!file) return;
        const id = typeof entry === 'object' && entry !== null && typeof entry.id === 'number' ? entry.id : index + 1;
        portfolioItems.push({
          id,
          image: `${base}/${file}`
        });
      });
    })
    .catch(() => {
      portfolioItems.length = 0;
    });
}
